import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Button, Dialog, DialogActions, DialogTitle, FormControl, FormControlLabel, Icon, IconButton, MenuItem, Radio, RadioGroup, Select, TextField, ThemeProvider, createTheme } from "@mui/material";

import MuiToggleButton from '@mui/material/ToggleButton'
import React from "react";

import { CustomerService } from "../../../service/customers.service";
//import { isNumber } from "lodash";
import Refresh from '@mui/icons-material/Refresh';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowLeftOutlined from '@mui/icons-material/ArrowForward';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import '../../../../src/App.css';
import { styled } from '@mui/material/styles';
import { error } from "console";
import { Enterprise } from "../../../model/enterprise.model";
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';

let selectedAssignedMap = new Map()
let selectedNotAssignedMap = new Map()

function SalesRepDetails() {
  const params = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = React.useState(1);
  
  const customerService = new CustomerService();
  
  const [userId, setUserId] = React.useState("");
  const [mappedEntList, setMappedEntList] = React.useState([]);
  const [unMappedEntList, setUnMappedEntList] = React.useState([]);
  const [selectedUnMappedEntList, setSelectedUnMappedEntList] = React.useState<any>([]);
  const [assignEnt, setAssignEnt] = React.useState(true);
  const [unAssignEnt, setUnAssignEnt] = React.useState(true);
  const [openConfirmDlg, setOpenConfirmDlg] = useState<any>(false);
  const [confirmMsg, setConfirmMsg] = React.useState<any>([]);

  const [selectedDropdownEntVal, setSelectedDropdownEntVal] = React.useState<any>("Select");
  const [selectedDropdownEntObj, setSelectedDropdownEntObj] = React.useState<any>();
  
  
  const location = useLocation();
  let parameters = {}

  const myComponent = {
    backgroundColor: "#F2F2F3",
    width:'100%',
    
    height: '50px',
    //overflow: 'scroll'
  };

  const imgComponent = {
    height: '25px'
    // display: inline-block

  };

  useEffect(()=>{
  /*  if (selectedAssignedMap) {
      selectedAssignedMap.forEach((value, key, map)=>{
        console.log(key + "  ::  "+value);
      })
   } */

    return()=>{
      if (selectedAssignedMap){
        selectedAssignedMap.clear()
      }
      if (selectedNotAssignedMap){
        selectedNotAssignedMap.clear()
      }
    }
  },[])


 
  let iscalled = false;
  useEffect(() => {
    console.log("+++++++++++++++Salessssss  : " + JSON.stringify(location))
    if (!iscalled) {
      iscalled = true


      if (location != null && location.state != null && location.state.salesRepDetails != null) {
        parameters = location.state.salesRepDetails;

        console.log("params :: ", parameters)
       
        let useridlocal = location.state.salesRepDetails.userid
        setStatus(location.state.salesRepDetails.status)
        setUserId(useridlocal)
        loadSalesRepINfo(useridlocal)

      }
    }
  }, [location]);




  const handleStatus = (event: React.ChangeEvent<HTMLInputElement>, value: Number) => {
    setStatus(Number(value));
  }

  function resetSelection(){
    setEnterpriseName([])
    //setUnassignedEnterpriseName([])
    if (selectedUnMappedEntList){
      setSelectedUnMappedEntList([])
    }
  }

  function onAddRemoveEnt(action:string){
    var entids = ""
    var salesRepid = -99
    var status = -1;
    var checkassignedEnt = "Y"
    if (action == "remove") {
      status = 0;
      checkassignedEnt = "N"
      salesRepid = Number(userId)
      if (selectedAssignedMap) {
        selectedAssignedMap.forEach((value, key, map) => {
          if (entids == ""){
            entids = key
          } else {
            entids = entids + "," + key
          }
          
        })
      }


      customerService.assignEntToSlaesRep(salesRepid , entids ,checkassignedEnt, status).then(resp=>{
        console.log("assigned ==:== "+resp.status)
        if (resp ){
          console.log("assigned ==: "+JSON.stringify(resp))
            if (resp.status == 100) {
  
  
              loadSalesRepINfo(userId)
  
           
            } else if (resp.status == 101){
              // show error msg 
            }
        } else {
  
        }
       // loadSalesRepINfo(userId)
      },onrejectionhandled=>{
  
      }).catch(error=>{
  
      })


    }
    if (action == "add") {
      status = 1;
      salesRepid = Number(userId)
      if (selectedUnMappedEntList) {
        selectedUnMappedEntList.map((value:any, index:number) => {
          if (entids == ""){
            entids = value.entId
          } else {
            entids = entids + "," + value.entId
          }
        })
      }

      customerService.assignEntToSlaesRep(salesRepid , entids ,checkassignedEnt, status).then(resp=>{
        console.log("assigned ==:== "+resp.status)
        if (resp ){
          console.log("assigned ==: "+JSON.stringify(resp))
            if (resp.status == 100) {
  
   
              console.log("assigned ==: "+JSON.stringify(resp.data.assignedUsers))
                if ( resp.data.assignedUsers && resp.data.assignedUsers.length>0) {
                    // show confirm dlg
                  
                    setOpenConfirmDlg(true)
                    setConfirmMsg(resp.data.assignedUsers )
                } else {
                  sendConfirmRequest()
                   // send confirm request with param "checkassignedEnt"
                }
            } else if (resp.status == 101){
              // show error msg 
            }
        } else {
  
        }
       // loadSalesRepINfo(userId)
      },onrejectionhandled=>{
  
      }).catch(error=>{
  
      })
    }
 
  }

  function sendConfirmRequest() {
    try {
      var entids = ""
     var status = 1;
     var  salesRepid = Number(userId)
      if (selectedUnMappedEntList) {
        selectedUnMappedEntList.map((value:any, index:number) => {
          if (entids == ""){
            entids = value.entId
          } else {
            entids = entids + "," + value.entId
          }
        })
      }
      customerService.assignEntToSlaesRep(salesRepid , entids, "N", status).then(resp=>{
        if (resp ){
            if (resp.status == 100) {
              loadSalesRepINfo(userId)
            } else if (resp.status == 101){
              // show error msg 
            }
        } else {
            // show error msg 
        }
       
      },onrejectionhandled=>{
             // show error msg 
      }).catch(error=>{
                 // show error msg 
      })
      
        
    } catch (error) {
       console.log(error)
    }
  }

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  const [enterpriseName, setEnterpriseName] = React.useState<string[]>([]);
  //const [enterpriseName, setEnterpriseName] = React.useState<string[]>([]);
  
  const handleChangeMultiple = (event: any) => {
    const { options } = event.target;
    const value: string[] = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setEnterpriseName(value);
  };

  const [unassignedEnterpriseName, setUnassignedEnterpriseName] = React.useState<string[]>([]);
  const handleChangeMultipleUnassigned = (event: any) => {
    const { options } = event.target;
    const value: string[] = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setUnassignedEnterpriseName(value);
  };

  useEffect(()=>{
    if (enterpriseName ){
       if (enterpriseName.length>0){
        setUnAssignEnt(false)
        setAssignEnt(true)
        setUnassignedEnterpriseName([])
        if (selectedNotAssignedMap) {
          selectedNotAssignedMap.clear()
        }
        
       } else {
        setUnAssignEnt(true)
       
       }
    }

  },[enterpriseName])

  
 
  
  useEffect(()=>{
    if (selectedUnMappedEntList){
      if (selectedUnMappedEntList.length>0){
         setAssignEnt(false)
         setUnAssignEnt(true)
         setEnterpriseName([])
         if (selectedAssignedMap){
          selectedAssignedMap.clear()
        }
      } else {
        setAssignEnt(true)
      }
    }

  },[selectedUnMappedEntList]) 

  const handleFormat = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    //alert(newFormats)
    setEnterpriseName(newFormats);
   
  };

  function loadSalesRepINfo(useridlocal:any) {
    const resp = customerService.getSalesRepEntDetails(useridlocal)
    resp.then(res=>{
        if (res) {
            console.log("respp :: ", res)
            if (res.data.length>0) {

               // reset dropdown
               setSelectedDropdownEntObj({entId: -1, entName: "Select", entAlias: "Select"})
               setSelectedDropdownEntVal( "Select")
              
                 for (let i = 0 ;i<res.data.length;i++) {
                    console.log("respp :: idd : ", res.data[i].salesPersonId)
                    try {
                      if (res.data[i].salesPersonId == useridlocal) {
                       
                        console.log("respp :: valll  : " )
                             res.data[i].entDetails.sort((a:any, b:any) => a.entAlias.localeCompare(b.entAlias))
                             setMappedEntList(res.data[i].entDetails)
                         } else if (res.data[i].salesPersonId == "-1") {
                          //  setMappedEntList([])
    
                            res.data[i].entDetails .sort((a:any, b:any) => a.entAlias.localeCompare(b.entAlias))
                            setUnMappedEntList(res.data[i].entDetails)
                         }
                    } catch (error) {
                       console.log("error"+error)
                    }                 
                 }

                 // clear previous things

                 //setMappedEntList([])
                 if (selectedAssignedMap){
                     selectedAssignedMap.clear()
                }
                if (selectedUnMappedEntList){
                  setSelectedUnMappedEntList([])
                }

                setEnterpriseName([])
                setUnassignedEnterpriseName([])
         

              

            } else {
                // no data 
            }
  
  
        } else {
  
        }
  
    }).catch(err=>{
  
    })
  }
  


  const handleFormat1 = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    setUnassignedEnterpriseName(newFormats);
   
  };

  function removeValue(value:any, index:any, arr:any) {
    // If the value at the current array index matches the specified value (2)
    console.log("variable filter value "+ value.entId + " :: "+ arr[index].entId);
    if (value.entId === arr[index].entId) {
    // Removes the value from the original array
        arr.splice(index, 1);
        return true;
    }
    return false;
}

  
const ToggleButton = styled(MuiToggleButton)(({  }) => ({
  '&.Mui-selected, &.Mui-selected:hover': {
    color: 'white',
  //  backgroundColor: selectedColor,
  },
}));

const filterOptions = (options:any, state:any) => {
  
  let newOptions : any= [];
  options.forEach((element:any) => {
    //alert(state.inputValue)
    console.log("logg : "+ state)
    if (
      
      element.entAlias
        .toLowerCase()
        .includes(state.inputValue.toLowerCase())
    )
      newOptions.push(element);
  });
  return newOptions;
};


interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}


function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
      <DialogTitle sx={{ m: 0, p: 2 ,minWidth:300 }} {...other}>
          {children}
          {onClose ? (
              <IconButton
                  aria-label="close"
                  onClick={onClose}
                  sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                  }}
              >
                  <CloseIcon />
              </IconButton>
          ) : null}
      </DialogTitle>
  );
}


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
      padding: theme.spacing(2),            
  },
  '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
  },
}));

function confirmAssign(){
  sendConfirmRequest()
  setOpenConfirmDlg(false)

}

function handleDlgClose() {
  setOpenConfirmDlg(false)
  setConfirmMsg("")
}


  return (
    <div className="App">
      <div className="border card p-0">
        <div className="border-bottom mt-3 col-md-12 row">
                    

                      {/* To List File */}
                     
                 

                   <div  className="scrollable-divparent">
                    <h6>Assigned Enterprises</h6>
                  <div  className="scrollable-div1 border" style={{marginLeft:10}} >
                    
                  <ToggleButtonGroup    
                  style={{alignSelf:'center'}}
                  orientation="vertical"
                 
                  id="assignedEnt"
                  value={enterpriseName} 
                  onChange={handleFormat}
                   >
                    
                      {mappedEntList.map((entDetails: any) => (
                          <ToggleButton 
                           
                          onClick={(param:any,value)=>{
                                //console.log("hass :: "+selectedAssignedMap.has(entDetails.entId));
                              if (!selectedAssignedMap.has(entDetails.entId)) {
                                selectedAssignedMap.set(entDetails.entId, entDetails.entAlias)
                              } else {
                                selectedAssignedMap.delete(entDetails.entId)
                              }
                              selectedAssignedMap.forEach((value, key, map)=>{
                                console.log(key + "  ::  "+value);
                              })                             
                          
                              
                          }}  
                          fullWidth
                          style={{backgroundColor: enterpriseName.includes(entDetails.entAlias)? '#A1D3F0': 'white' ,
                          border: '0px',height:30, justifyContent: "flex-start"
                           }}
                            key={entDetails.entId + ""} value={entDetails.entAlias}>
                              {entDetails.entAlias}
                          </ToggleButton>
                      ))}
                  </ToggleButtonGroup>
                  </div>
                  </div>   

                 
                  <div style={{ height: '300px', width: '20% ' }} className="mb-4 col"  > 
                  <p>Actions</p>
                  <br></br>
                  
                  

                      <Button className="border border-color: red; "  style={{width:'100%', padding:0 , backgroundColor:unAssignEnt? '#ffffff' : '#7BE071'}}
                       onClick={() => onAddRemoveEnt("remove")}   disabled={unAssignEnt} ><i className="" aria-hidden="true">   </i>
                      {(
                          <IconButton style={{width:36 , height:36 ,}} >
                              <ArrowLeftOutlined fontSize='small'   style={{ color: "grey" }}/>

                          </IconButton>
                          )}</Button>
                       
                      <Button className="border mt-10"  
                      onClick={() => onAddRemoveEnt("add")} 
                      style={{width:'100%',marginTop:15,padding:0 , backgroundColor:assignEnt? '#ffffff' : '#7BE071'}} disabled={assignEnt} ><i className="" aria-hidden="true">   </i>
                       { (
                          <IconButton style={{width:36 , height:36}} >
                              <ArrowBack fontSize='small' style={{ color: "grey" }}/>
                              
                          </IconButton>
                       )}
                        </Button>

                  </div>

                  <div  className="autoselect-div ">
                  <h6>Enterprises</h6>

                  <Autocomplete
                  
                  filterOptions={filterOptions}
                  size="small" 
                  value={selectedDropdownEntObj}
                  inputValue={selectedDropdownEntVal}
                  defaultValue={{entId: -1, entName: "Select", entAlias: "Select"}}
                  onInputChange={(event: any, newValue: any,reason:any)=>{
                   
                    setSelectedDropdownEntVal(newValue)
                  }}
                  onChange={(event: any, newValue: any) => {
                    
                    //setValue(newValue);
                   // setSelectedEntprise(newValue?.entId!!) //  (event.target.value)
                  // setSelectedDropdownEntVal(newValue)
                   if (newValue) {
                    let hasEntry = false
                    for (let i=0;i<selectedUnMappedEntList.length;i++) {
                          if (selectedUnMappedEntList[i].entId == newValue.entId) {
                              hasEntry =  true
                              break
                          }
                    }
                     if (!hasEntry){

                      const temparr = [...selectedUnMappedEntList,newValue]
                      setSelectedUnMappedEntList(temparr)
                     }


                     // reset dropdown
                      setSelectedDropdownEntVal( newValue. entAlias)
                      setSelectedDropdownEntObj(newValue)

                   }
                  }}
               
                  id="controllable-states-demo"
                  options={unMappedEntList}
                  
                  getOptionLabel={(option) => option.entAlias}                  
                  renderInput={(params) => <TextField {...params} label="Enterprise Name" />}

                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.entId}>
                        {option.entAlias}
                      </li>
                    );
                  }}


                />
                
                {/*  <ToggleButtonGroup    
                   
                  style={{alignSelf:'center'}}
                  orientation="vertical"
                 
                  id="assignedEnt"  value={unassignedEnterpriseName} 
                  onChange={handleFormat1}
                   >
                    
                      {selectedUnMappedEntList.map((entDetails: any) => (
                          <ToggleButton 

                          onClick={(param:any,value)=>{
                       
                              // Pass the removeValue function into the filter function to return the specified value
                              
                              const temparr = JSON.parse(JSON.stringify(selectedUnMappedEntList))
                              const temparr2 = []
                            //  const x = temparr.filter(removeValue);
                              for (let i=0;i<temparr.length;i++){
                                  if (temparr[i].entId != entDetails.entId) {
                                    temparr2.push(temparr[i])
                                  }
                              }
                              
                              setSelectedUnMappedEntList(temparr2)
                              
                          
                         }} 
                          
                          fullWidth
                          style={{backgroundColor: '#A1D3F0' , 
                            marginTop:2,
                            border: '0px',height:30, justifyContent: "flex-start"
                           
                       }}
                            key={entDetails.entId + ""} value={entDetails.entName}>
                              {entDetails.entName}
                          </ToggleButton>
                      ))}
                  </ToggleButtonGroup>
                    */ }

              <div className="scrollable-div col border mt-2" >
                {selectedUnMappedEntList && selectedUnMappedEntList
                  .map((getordersList: any, index: number) => {
                    return (
                      <div className="mt-1 mb-1 "  style={{width:'100%' ,  height:'auto'  , 
                      textAlign:'left' ,
                    }} >
                      <Button className="border border-color: red; "  style={{width:'auto', paddingLeft:3 , paddingRight:0, paddingTop:2,paddingBottom:2,
                       backgroundColor:'#ffffff' ,
                     
                      }}
                       ><i className="" aria-hidden="true">   </i>
                     {getordersList.entAlias}  {(
                            <IconButton style={{ width: 36, height: 36, }} onClick={() => {
                              const temparr = JSON.parse(JSON.stringify(selectedUnMappedEntList))
                              const temparr2 = []
                              //  const x = temparr.filter(removeValue);
                              for (let i = 0; i < temparr.length; i++) {
                                if (temparr[i].entId != getordersList.entId) {
                                  temparr2.push(temparr[i])
                                }
                              }

                              setSelectedUnMappedEntList(temparr2)
                            }}  >
                              <ClearIcon fontSize='small' htmlColor='red' />

                            </IconButton>
                         )} </Button>

                          </div>
                    );
                  })}



              </div>
              
                  </div>
        
          <div className="card-footer col-12 text-center">
            <Button style={{ color: "green" }} className="mr-4" onClick={() => resetSelection()} variant="text" startIcon={<Refresh />}>
              Reset
            </Button>
            <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../salesrep')} variant="text" startIcon={<ClearOutlinedIcon />}>
              Cancel
            </Button>
          </div>
          <ToastContainer />
        </div>

      </div>


       
      <BootstrapDialog

        //fullWidth
        //  maxWidth={"sm"}
        // style={{width:'100%'}}             
        onClose={handleDlgClose}
        aria-labelledby="customized-dialog-title"
        open={openConfirmDlg}>

        <BootstrapDialogTitle
          id="customized-dialog-title center" onClose={handleDlgClose}>
         {"Already Assigned to"} 
        </BootstrapDialogTitle>

         { confirmMsg && 
            

          confirmMsg.map(function(value:any, i:any){
            return (<p style={{ fontSize: 16, marginLeft:20}} >{value.username+"("+ value.mobileno+")"}</p>)
            ;
          })         
          
         }
     

        <DialogActions>

          <Button onClick={handleDlgClose}>Cancel</Button>
          <Button onClick={confirmAssign}>Assign</Button>

        </DialogActions>
      </BootstrapDialog>

    </div>

  );
}

export default SalesRepDetails;

